import {
    composeQueryParameter,
    decomposeSearchStringToParams
} from "@src/common/service/urlHandler";

/**
 * 絞り込みを伴う検索を実行する
 */
export const initSearchExecuter = () => {
    // find jobs押下で検索実行
    $('.s-search_btn').on('click', (e) => {
        e.preventDefault();
        execute();
    });

    // エンター押下でも検索実行
    $('#s-keywordSearch1_fire, #s-locationSearch1_fire').on('keydown', (e) => {
        if (e.key === 'Enter') {
            execute();
        }
    });
}

/**
 * execute を実行するメソッドを公開する。
 */
export const executeSearch = () => {
    execute();
}

/**
 * 遷移先URLを取得し、パラメータ付与して検索を実行する
 *
 * @return {Promise<void>}
 */
const execute = async () => {
    const keywordSearchValue = $('#s-keywordSearch1_fire').val().replaceAll('/', ' ');
    const locationSearchValue = $('#s-locationSearch1_fire').val().replaceAll('/', ' ');
    // 入力値が空ならサジェストが残っていても無視する
    const locationSuggestValue = locationSearchValue === '' ? '' : $('#s-firstSuggest').text();

    // 入力値をエンコードしてパラメータをセット
    const apiUrlWithParams = generateUrlApiPath
        + '?'
        + `keyword=${encodeURIComponent(keywordSearchValue)}`
        + '&'
        + `location=${encodeURIComponent(locationSearchValue)}`
        + '&'
        + `locationSuggest=${encodeURIComponent(locationSuggestValue)}`;

    // 送客課金ページかつキーワード・勤務地の検索条件が同じであれば、遷移先も送客課金/クローラ用ページにする
    const _isFromPaidJob = typeof isFromPaidJob !== 'undefined' ? isFromPaidJob : false;
    const _isFromCrawler = typeof isFromCrawler !== 'undefined' ? isFromCrawler : false;
    const _searchedKeyword = typeof searchedKeyword !== 'undefined' ? searchedKeyword : null;
    const _searchedLocation = typeof searchedLocation !== 'undefined' ? searchedLocation : null;
    const toPaid = _isFromPaidJob && _searchedKeyword === keywordSearchValue && _searchedLocation === locationSearchValue;
    const toCrawler = _isFromCrawler && _searchedKeyword === keywordSearchValue && _searchedLocation === locationSearchValue;

    try {
        // 遷移先URL生成のAPIを呼ぶ
        const response = await fetch(apiUrlWithParams);
        const result = await response.json();
        let searchUrl = result.url;
        const $form = $('#s-search_form');

        // メインフォームから給与上限下限の絞り込みパラメータ取得
        const salaryMinValue = $form.find(`input[name="${narrowSearchParamsViewModel.salaryMinParamKey}"]`).val() || '';
        const salaryMaxValue = $form.find(`input[name="${narrowSearchParamsViewModel.salaryMaxParamKey}"]`).val() || '';

        // 給与上限下限の絞り込みパラメータを正規フォームに追加
        let minValue = salaryMinValue;
        let maxValue = salaryMaxValue;

        // 下限 > 上限 となっている場合は入れ替える
        if (minValue && maxValue && parseFloat(minValue) > parseFloat(maxValue)) {
            [minValue, maxValue] = [maxValue, minValue];
        }

        // フォームに値を設定
        if (minValue) {
            $form.find(`input[name="${narrowSearchParamsViewModel.salaryMinParamKey}"]`).val(minValue);
        }
        if (maxValue) {
            $form.find(`input[name="${narrowSearchParamsViewModel.salaryMaxParamKey}"]`).val(maxValue);
        }

        const featureValueList = [];
        const featureCategoryList = narrowSearchParamsViewModel.featureCategories;

        // 仮フォームから特徴の絞り込みパラメータ取得
        for (let key in featureCategoryList) {
            // featureCategoryList : ["Remote" => "remote",...]
            const categoryName = featureCategoryList[key];
            const $featureForm = $(`#s-feature_form_${categoryName}`);

            $featureForm[0][categoryName].forEach((form) => {
                if ($(form).prop('checked')) {
                    featureValueList.push($(form).val());
                }
            });
        }

        // 特徴の絞り込みパラメータを正規フォームに追加
        $form.append($('<input>').attr({
            'type': 'hidden',
            'name': narrowSearchParamsViewModel.featureParamKey,
            'value': featureValueList.filter(value => value !== '')
        }));

        // 空のクエリパラメータを除去
        cleanEmptyQuery($form);
        // Distance絞り込み無効化
        if (!result.isFilterableByDistance) {
            removeDistanceQuery($form);
        }
        // 遷移先URLがトップのとき（キーワード・勤務地が空のとき）はクエリパラメータ無効化
        if (searchUrl === '/') {
            removeAllQuery($form);
        }
        // URLにパラメータ付ける
        const formParams = $form.serialize();
        const hasParams = formParams !== '';
        
        if (hasParams || toPaid || toCrawler) {
            const queryParts = [];
            
            if (hasParams) {
                queryParts.push(formParams);
            }
            
            if (toPaid) {
                queryParts.push('type=pft');
            } else if (toCrawler) {
                queryParts.push('type=crawler_access');
            }
            
            searchUrl += '?' + queryParts.join('&');
        }

        // 検索パラメータの順番整理
        if (searchUrl.includes('?')) {
            const sortedSearchParamString = sortSearchParam(searchUrl);
            searchUrl = result.url + sortedSearchParamString;
        }

        // AA タグ送信
        analytics.executeSearch();
        // 検索実行
        location.href = searchUrl;
    } catch (error) {
        // 一旦何もしない
        console.log(error);
    }
}

/**
 * クエリパラメータの順序を整理する
 *
 * @param searchUrl
 * @return {string}
 */
export const sortSearchParam = (searchUrl) => {
    const currentSearchString = searchUrl.split('/')[3];
    const searchParam = decomposeSearchStringToParams(currentSearchString);
    return composeQueryParameter(searchParam);
}

/**
 * クエリパラメータを全て無効化する
 *
 * @param $form
 */
const removeAllQuery = ($form) => {
    const params = $form.serializeArray();

    // パラメータを全削除
    for (let param of params) {
        Array.from($form[0]).forEach((formPart) => formPart.disabled = true);
    }
};

/**
 * Distanceクエリパラメータを無効化する
 *
 * @param $form
 */
const removeDistanceQuery = ($form) => {
    const distanceFormPart = Array.from($form[0])
        .find(formPart => formPart.name === narrowSearchParamsViewModel.distanceParamKey && formPart.checked);

    if (distanceFormPart !== undefined) {
        distanceFormPart.disabled = true;
    }
};

/**
 * 空またはデフォルト値のクエリパラメータを無効化する
 *
 * @param $form
 */
const cleanEmptyQuery = ($form) => {
    const params = $form.serializeArray();

    for (let param of params) {
        // パラメータ値が空もしくはデフォルト値ならパラメータ自体を削除
        if (
            param['value'] === ''
            || param['value'] === '0'
            || (param['name'] === narrowSearchParamsViewModel.distanceParamKey && param['value'] === distanceDefaultValue.toString())
        ) {
            const emptyFormPart = Array.from($form[0]).filter((formPart) => formPart.name === param['name']);
            emptyFormPart.forEach((formPart) => formPart.disabled = true);
        }
    }
}
